<template>
  <component
    v-if="loaded"
    v-bind:is="currentComponent"
    :ref="this.destination.type"
    @change-form="changeForm"
    :isCompany="isCompany"
    :isAdmin="isAdmin"
  ></component>
</template>

<script>
import EdCustomDestination from "@/view/pages/destinations/edit-comp/EdCustomDestination";
import EdFacebookDestination from "@/view/pages/destinations/edit-comp/EdFacebookDestination";
import EdInstagramDestination from "@/view/pages/destinations/edit-comp/EdInstagramDestination";
import EdInstagramRtmpDestination from "./edit-comp/EdInstagramRtmpDestination.vue";
import EdYoutubeDestination from "@/view/pages/destinations/edit-comp/EdYoutubeDestination";
import EdTelegramDestination from "@/view/pages/destinations/edit-comp/EdTelegramDestination";
import EdTwitterDestination from "@/view/pages/destinations/edit-comp/EdTwitterDestination";
import EdTwitchDestination from "@/view/pages/destinations/edit-comp/EdTwitchDestination";
import EdAparatDestination from "@/view/pages/destinations/edit-comp/EdAparatDestination";
import EdRubikaDestination from "@/view/pages/destinations/edit-comp/EdRubikaDestination";
import EdSoroushplusDestination from "@/view/pages/destinations/edit-comp/EdSoroushplusDestination";
import EdTekyeDestination from "@/view/pages/destinations/edit-comp/EdTekyeDestination";
import EdArvancloadDestination from "@/view/pages/destinations/edit-comp/EdArvancloadDestination";
import EdShadDestination from "@/view/pages/destinations/edit-comp/EdShadDestination";
import EdEitaaDestination from "@/view/pages/destinations/edit-comp/EdEitaaDestination";
import instagram from "@/core/mixins/instagram";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import {
  FETCH_DESTINATION,
  DESTROY_DESTINATION,
  UPDATE_DESTINATION
} from "@/core/services/store/destinations.module";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "destinations-show",
  mixins: [instagram],
  data() {
    return {
      loaded: false,
      isCompany: this.$route.name.startsWith("company"),
      isAdmin: this.$route.name.startsWith("admin")
    };
  },
  components: {
    EdCustomDestination,
    EdFacebookDestination,
    EdInstagramDestination,
    EdInstagramRtmpDestination,
    EdYoutubeDestination,
    EdTelegramDestination,
    EdTwitterDestination,
    EdTwitchDestination,
    EdAparatDestination,
    EdRubikaDestination,
    EdSoroushplusDestination,
    EdTekyeDestination,
    EdArvancloadDestination,
    EdShadDestination,
    EdEitaaDestination,
  },

  mounted() {
    let destinationsRouteName = this.isCompany
      ? "company-destinations-index"
      : "destinations-index";

    this.$store.dispatch(FETCH_DESTINATION, this.$route.params.id).then(() => {
      this.loaded = true;
      this.setBreadcrumbs();
      this.$store.dispatch(SET_ACTIONS, {
        buttons: [
          {
            name: "ذخیره",
            event: "edit-destination-event",
            class: "btn-primary",
            id: "edit-destination-btn"
          },
          {
            name: '<i class="flaticon2-trash"></i>حذف',
            event: "delete-destination-event",
            class: "btn-danger"
          }
        ]
      });
    });

    this.eventHub.$on("edit-destination-event", () => {
      let $this = this.$refs[this.destination.type];

      $this.fv.validate().then(status => {
        if (status === "Valid") {
          let submitBtn = document.getElementById("edit-destination-btn");
          this.disableBtn(submitBtn);

          this.$store
            .dispatch(UPDATE_DESTINATION, $this.form)
            .then(() => {
              if (this.destination.type === 3) {
                this.loginToInstagram(this.destination.id);
              }

              this.$router.push({
                name: destinationsRouteName
              });

              this.enableBtn(submitBtn);
            })
            .catch(() => {
              this.enableBtn(submitBtn);
            });
        } else if (status === "Invalid") {
          this.showError("لطفا فرم را به شکل صحیح کامل کنید");
        }
      });
    });
    this.eventHub.$on("delete-destination-event", () => {
      this.deleteDestination();
    });
  },
  beforeDestroy() {
    this.eventHub.$off(["edit-destination-event", "delete-destination-event"]);
    document.getElementById("edit-destination-btn").disabled = false;
  },
  methods: {
    setBreadcrumbs() {
      let destinationsRouteName = "destinations-index";

      let items = [];
      if (this.isCompany) {
        destinationsRouteName = "company-destinations-index";

        items.push({
          title: this.currentUserProperty.title ?? "شرکت",
          route: { name: "company-dashboard" }
        });
      }
      if (this.isAdmin) {
        destinationsRouteName = "admin-destinations-index";

        items.push({
          title: "مدیریت",
          route: { name: "admin-dashboard" }
        });
      }

      items.push({ title: "مقصد‌ها", route: { name: destinationsRouteName } });
      items.push({ title: this.destination.name });

      this.$store.dispatch(SET_BREADCRUMB, items);
    },
    changeForm(e) {
      document.getElementById("edit-destination-btn").disabled = e;
    },
    deleteDestination() {
      let destinationsRouteName = this.isCompany
        ? "company-destinations-index"
        : "destinations-index";

      Swal.fire({
        title: "",
        text: "آیا از حذف مقصد اطمینان دارید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "بله",
        confirmButtonColor: "#4554a0",
        cancelButtonText: "خیر",
        cancelButtonColor: "#ed1c24",
        heightAuto: false
      }).then(result => {
        if (result.isConfirmed) {
          this.$store
            .dispatch(DESTROY_DESTINATION, this.destination.id)
            .then(() => {
              this.$router.push({ name: destinationsRouteName });
            });
        }
      });
    }
  },
  computed: {
    ...mapGetters(["destination", "destinationTypes"]),

    currentComponent: function() {
      let name = this.destinationTypes[this.destination.type];

      return name
        ? `Ed${this.capitalize(name)}Destination`
        : "EdUnknownDestination";
    }
  }
};
</script>
